import Swiper from "@modules/swiper";
import { Navigation, Pagination, A11y, Keyboard } from "@modules/swiper/modules";

var language = document.getElementsByTagName("html")[0].getAttribute("lang");
var SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Bild anzeigen";
var SlideMessageNext = language === "it" ? "Mostra immagine successiva" : "Nächstes Bild anzeigen";

export function slideNews() {
  const swiperElementNews = document.querySelector(".slide-news");
  if (swiperElementNews) {
    // Crea l'istanza del Swiper
    new Swiper(swiperElementNews, {
      modules: [Navigation, A11y, Keyboard, Pagination],
      slidesPerView: 1.2,
      spaceBetween: 20,

      a11y: {
        prevSlideMessage: SlideMessagePrev,
        nextSlideMessage: SlideMessageNext,
      },

      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
        enabled: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      grabCursor: true,
      navigation: {
        prevEl: ".arrow-left-news",
        nextEl: ".arrow-right-news",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1500: {
          slidesPerView: 3,
        },
      },
    });

    //console.log("Nuovo slider Swiper inizializzato:", slideNews);
  }
}

export function slideStories() {
  const swiperElementStories = document.querySelector(".slide-stories");
  if (swiperElementStories) {
    //console.log("ESISTEstories");
    new Swiper(swiperElementStories, {
        modules: [Navigation, A11y, Keyboard, Pagination],
        
      a11y: {
        prevSlideMessage: SlideMessagePrev,
        nextSlideMessage: SlideMessageNext,
        },
   
      slidesPerView: 1.2,
      slideToClickedSlide: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
        enabled: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      grabCursor: true,
      navigation: {
        prevEl: ".arrow-left-stories",
        nextEl: ".arrow-right-stories",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
         
        },
        1000: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    });
      //console.log("Nuovo news inizializzato:", slideStories);
  }
}
